import { eachDayOfInterval } from 'date-fns';

/**
 * Returns an array of dates within a given range.
 *
 * @param {Date} start - The start date of the range.
 * @param {Date} end - The end date of the range.
 * @returns {Date[]} An array of dates within the given range.
 */
export const getRangeOfDates = (start: Date, end: Date) => {
    return eachDayOfInterval({
        start,
        end
    });
};
